import calculateVerticalAngleOfView from 'helpers/calculations/calculateVerticalAngleOfView'
import parseResolutions from 'helpers/parseResolutions'
import calculateAspectRatio from 'helpers/calculations/calculateAspectRatio'

export default function convertHorizontalAngleOfViewToVertical({ horizontalAngleOfView, resolution }) {
  const { horizontal, vertical } = parseResolutions(resolution)

  return calculateVerticalAngleOfView({
    aspectRatio: calculateAspectRatio({ horizontalResolution: horizontal, verticalResolution: vertical }),
    horizontalAngleOfView
  })
}



// WEBPACK FOOTER //
// ./src/helpers/convertHorizontalAngleOfViewToVertical.js